import "./planoption.scss";

import config from "../../app.json";
import axios from "axios";

import { numberHasDecimal } from "../../helper";
import { Button, Col, Row } from "react-bootstrap";
import { Context } from "../../Reducers/Store";
import React, { useEffect, useState, useContext } from "react";
import Rectangle from "../Rectangle/rectangle";
import { useNavigate, Navigate } from "react-router-dom";
import AlertComponent from "../AlertComponent";

const PlanOption = (props) => {
  const [state, dispatch] = useContext(Context);
  const { id, name, description, bestOption, periodicity, mainFeatures, features, prices, selectPlan, requirePost, currentPlan, freeTrialDays, jwtMobile } = props;
  const navigate = useNavigate();
  const [priceMonth, setPriceMonth] = useState(0);
  const [priceYear, setPriceYear] = useState(0);
  const [fullPriceYear, setFullPriceYear] = useState(0);
  const [priceMonthId, setPriceMonthId] = useState(0);
  const [priceYearId, setPriceYearId] = useState(0);
  const [priceYearPerMonth, setPriceYearPerMonth] = useState(0);
  const [allowSelect, setAllowSelect] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState(null);

  useEffect(() => {
    const yearly = prices.filter((x) => x.periodicity === "Yearly");
    if (yearly) {
      const yearlyPrice = yearly?.at(0)?.value ?? 0;
      const yearlyPriceId = yearly?.at(0)?.id ?? 0;
      const yearlyMonth = yearlyPrice / 12;
      setFullPriceYear(yearlyPrice);
      setPriceYear(yearlyMonth);
      setPriceYearPerMonth(yearlyMonth);
      setPriceYearId(yearlyPriceId);
    }
    const monthly = prices.filter((x) => x.periodicity === "Monthly");
    if (monthly) {
      const monthlyPriceId = monthly?.at(0)?.id ?? 0;
      setPriceMonthId(monthlyPriceId);
      setPriceMonth(monthly?.at(0)?.value ?? 0);
    }

    setAllowSelect(selectPlan);
  }, [0]);

  useEffect(() => {
    if (subscriptionId) {
      dispatch({ type: "SET_LOADING", payload: true });

      axios
        .get(config.API_HM + "/profile")
        .then((result) => {
          dispatch({ type: "SET_PROFILE", payload: result.data });
          return navigate(`/subscriptionCompleted`, { state: { subscriptionId: subscriptionId } });
        })
        .catch((error) => {
          AlertComponent("Error", error.message ?? "Something went wrong. Profile could not be loaded. Code: 7", { icon: `error` });
        })
        .finally(() => {
          dispatch({ type: "SET_LOADING", payload: false });
        });
    }
  }, [subscriptionId]);

  const handleUpgrade = () => {
    if (!allowSelect && !selectPlan) {
      window.location.replace("https://www.socialchimp.ai/contact");
      return;
    }

    const payload = {
      planId: id,
      planName: name,
      planSmallDescription: description,
      planPriceMonth: priceMonth,
      planFullPriceYear: fullPriceYear,
      PlanPriceYear: priceYear,
      planMainFeatures: mainFeatures,
      planAllFeatures: features,
      planBestOption: bestOption,
      planAllowSelect: allowSelect,
      planPriceYearPerMonth: priceYearPerMonth,
      planPeriodicity: periodicity,
      planPriceMonthId: priceMonthId,
      planPriceYearId: priceYearId,
      planSubscriptionId: !requirePost,
      freeTrialDays: freeTrialDays,
    };

    var nextPage = `/payment`;
    if (jwtMobile) {
      payload.jwtMobile = jwtMobile;
      nextPage = `/paymentMobile`;
    }

    if (priceMonth === 0) {
      createSubscription();
      return;
    }
    
    return navigate(nextPage, {
      state: payload,
    });
  };

  const createSubscription = async () => {
    const payload = {
      planId: id,
      priceId: periodicity === "mo" ? priceMonthId : priceYearId,
      promoCode: null,
      payment: null,
    };

    await axios
      .post(config.API_HM + "/subscriptions", payload)
      .then((res) => {
        setSubscriptionId(res.data.id);
      })
      .catch(function (error) {
        return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
      });
  };

  const renderPrice = numberHasDecimal(periodicity === "mo" ? priceMonth : priceYear);
  let buttonText = `Choose Plan`;

  if (!selectPlan && currentPlan) {
    buttonText = `Current Plan`;
  } else if (requirePost) {
    buttonText = `Choose Plan`;
  } else {
    if (allowSelect || selectPlan) {
      buttonText = `Choose Plan`;
    } else {
      buttonText = `Downgrade`;
    }
  }

  const disabledClass = !selectPlan && currentPlan ? "disabled" : "";
  const fullMessage = <small className="plan-fullprice">{periodicity === `mo` ? "" : `${numberHasDecimal(fullPriceYear)}/year`}</small>;
  const hasFreeDays = freeTrialDays && freeTrialDays > 0;
  let freeDaysMessage = hasFreeDays ? <span>1 Day <b>FREE</b> Trial, </span> : null;
  if (hasFreeDays && freeTrialDays > 1) {
    freeDaysMessage = <span>{freeTrialDays} Days <b>FREE</b> Trial, </span>;
  }

  return (
    <div className={`plan-option ${bestOption ? `best-option` : ``}`} key={`planOpt_${id}`}>
      <Row>
        <Col>
          <h4>{name}</h4>
        </Col>
        <Col className="d-flex justify-content-end">{bestOption && <Rectangle title={`Popular`} className={`popular-opt`} />}</Col>
      </Row>
      <small className="plan-description">{freeDaysMessage}{description}</small>

      <Row>
        <div>
          <h2>
            $ {renderPrice}
            <span className="plan-periodicity"> / mo</span>
            <Row>
              {fullMessage}
            </Row>
          </h2>
        </div>
      </Row>

      <small>{mainFeatures}</small>

      <Row>
        <ul className="plan-opt">
          {features?.map((x, index) => (
            <li key={"item_plan_opt" + index + "_" + x.id}>
              <span></span>
              <div>{x}</div>
            </li>
          ))}
        </ul>
      </Row>

      <Row>
        {/* <Button className="select-plan-btn" disabled={!allowSelect} onClick={handleUpgrade}> */}
        <Button className={`select-plan-btn ${disabledClass}`} onClick={handleUpgrade}>
          {buttonText}
        </Button>
      </Row>
    </div>
  );
};
export default PlanOption;
